import { createSlice } from "@reduxjs/toolkit";

// Load initial state from localStorage if available
const getInitialState = () => {
	try {
		const savedFilters = localStorage.getItem("shared_filters");
		return savedFilters ? JSON.parse(savedFilters) : {};
	} catch (error) {
		console.error("Error loading filters from localStorage:", error);
		return {};
	}
};

const sharedFilterSlice = createSlice({
	name: "sharedFilters",
	initialState: getInitialState(),
	reducers: {
		setTicketCategoryFilter: (state, action) => {
			const { projectId, ticketCategoryId } = action.payload;

			if (!projectId) {
				console.warn(
					"Cannot set ticket category filter without projectId",
				);
				return;
			}

			// Initialize project entry if it doesn't exist
			if (!state[projectId]) {
				state[projectId] = {};
			}

			// Set the ticket category ID for this project
			state[projectId].ticketCategoryId = ticketCategoryId;
		},
		resetFilters: (state, action) => {
			const projectId = action.payload;

			if (projectId && state[projectId]) {
				// Reset filters for specific project
				delete state[projectId];
			} else if (!projectId) {
				// Reset all filters if no project ID provided
				return {};
			}
		},
	},
});

export const { setTicketCategoryFilter, resetFilters } =
	sharedFilterSlice.actions;

// Modified selector that takes projectId directly as an argument
export const selectTicketCategoryFilter = (state, projectId) => {
	// If projectId is provided directly, use it
	if (projectId && state.sharedFilters && state.sharedFilters[projectId]) {
		return state.sharedFilters[projectId].ticketCategoryId || "";
	}

	// Fall back to getting projectId from state if not provided
	const stateProjectId = state.projectDetails?.id;
	if (
		stateProjectId &&
		state.sharedFilters &&
		state.sharedFilters[stateProjectId]
	) {
		return state.sharedFilters[stateProjectId].ticketCategoryId || "";
	}

	return "";
};

export default sharedFilterSlice.reducer;
